import { createApiClient } from './http';
import { Response } from '../entities/Response';
import { ScriptExecution, ScriptExecutionCommandType, ScriptExecutionFile, ScriptExecutionInfo, ScriptExecutionRunResult, ScriptExecutionServer } from '../entities/Script';

const apiClient = createApiClient({ timeoutInMills: 300000 });

export default class ScriptExecutionService {
    static async listScripts(request: { environment: string }): Promise<ScriptExecutionInfo[]> {
        const response = await apiClient.post('/service/script/list', request);
        return response.data || [];
    }

    static async createScript(request: { environment: string; scriptName: string; scriptPath: string; defaultCommand?: string; commandTemplates?: string; content: string }): Promise<Response<ScriptExecution>> {
        return await apiClient.post('/service/script/create', request);
    }

    static async getScript(request: { environment: string; scriptName: string }): Promise<ScriptExecution | null> {
        const response = await apiClient.post('/service/script/get', request);
        return response.data;
    }

    static async updateScript(request: { id: number; scriptPath: string; defaultCommand?: string; commandTemplates?: string; content: string; environment: string; scriptName: string }): Promise<Response<ScriptExecution>> {
        return await apiClient.post('/service/script/update', request);
    }

    static async syncScript(request: { environment: string; scriptName: string; targetEnvironments: string[] }): Promise<Response<ScriptExecution[]>> {
        return await apiClient.post('/service/script/sync', request);
    }

    static async listFiles(request: { environment: string; scriptName: string }): Promise<ScriptExecutionFile[]> {
        const response = await apiClient.post('/service/script/file/list', request);
        return response.data || [];
    }

    static async saveFile(request: { environment: string; scriptName: string; fileName: string; targetPath: string; content: string }): Promise<Response<ScriptExecutionFile>> {
        return await apiClient.post('/service/script/file/save', request);
    }

    static async deleteFile(request: { environment: string; scriptName: string; fileName: string }): Promise<Response<void>> {
        return await apiClient.post('/service/script/file/delete', request);
    }

    static async listServers(request: { environment: string; scriptName: string }): Promise<ScriptExecutionServer[]> {
        const response = await apiClient.post('/service/script/server/list', request);
        return response.data || [];
    }

    static async deployScript(request: { environment: string; scriptName: string; allServers: boolean; serverIps: string[] }): Promise<ScriptExecutionRunResult[]> {
        const response = await apiClient.post('/service/script/deploy', request);
        return response.data || [];
    }

    static async runScript(request: {
        environment: string;
        scriptName: string;
        allServers: boolean;
        serverIps: string[];
        commandType: ScriptExecutionCommandType;
        command: string;
        deployBeforeRun: boolean;
    }): Promise<ScriptExecutionRunResult[]> {
        const response = await apiClient.post('/service/script/run', request);
        return response.data || [];
    }
}
